<h1 mat-dialog-title [class]="'MapTitle'">{{title | translate}}</h1>
<div mat-dialog-content class="p-0">
  @if (showRoute) {
      <div   [class.map-container-small]="isEmbeded || isSmallDevice"
             [class.map-container]="!isEmbeded && !isSmallDevice">>
        <google-map   #Map [center]="{ lat, lng}"  [zoom]="zoom" height="100%" width="100%">
          <map-marker [options]="{draggable : true}"  (mapDragend)="markerDragEnd(coordinates.lat, coordinates.lng, $event)"
                      [position]="coordinates.LatLng"></map-marker>
        </google-map>
      </div>
  } @else {
      @if (_googleUrlForRoute!=null) {
          <div    [class.map-container-small]="isEmbeded || isSmallDevice"
                  [class.map-container]="!isEmbeded && !isSmallDevice">>
            <google-map #Map2 [zoom]="zoom" height="100%" width="100%">
              <map-marker [options]="{draggable : false}"   [position]="puPoint.LatLng"></map-marker>
              <map-marker [options]="{draggable : false}"   [position]="doPoint.LatLng"></map-marker>
              @if (showRoute) {
                <map-directions-renderer  ></map-directions-renderer>
              }
            </google-map>
          </div>
      } @else {
          <iframe   width="600" height="450" [src]="iframeSrc"></iframe>
      }

  }


</div>
@if (showRoute) {
    @if (isEmbeded != undefined &&  !isEmbeded) {
      <div mat-dialog-actions >
        <button  mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
      </div>
    }
} @else {
    <div mat-dialog-actions>
      <button  mat-button (click)="onNoClick()">{{'Cancel' | translate}}</button>
      <button  mat-button [mat-dialog-close]="coordinates" cdkFocusInitial (click)="onUpdateClick()">{{'Update' | translate}}</button>
    </div>
}


